<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path
          d="M862.1 746 843 735c2.5-9.9 3.8-20.3 3.8-30.9s-1.3-21-3.8-30.9l19.2-11.1c16.7-9.7 22.5-31 12.8-47.8-9.6-16.7-31-22.5-47.8-12.8L808 612.6c-14.8-14.3-33.1-25.1-53.5-30.9v-22.1c0-19.3-15.7-35-35-35s-35 15.7-35 35v22.1c-20.4 5.8-38.7 16.6-53.5 30.9l-19.2-11.1c-16.7-9.6-38.1-3.9-47.8 12.8-9.7 16.7-3.9 38.1 12.8 47.8l19.2 11.1c-2.5 9.9-3.8 20.3-3.8 30.9s1.3 21 3.8 30.9l-19.1 11c-16.7 9.7-22.5 31-12.8 47.8 6.5 11.2 18.2 17.5 30.3 17.5 5.9 0 11.9-1.5 17.5-4.7l19.2-11.1c14.8 14.3 33.1 25.1 53.5 30.9v22.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-22.1c20.4-5.8 38.7-16.6 53.5-30.9l19.2 11.1c5.5 3.2 11.5 4.7 17.5 4.7 12.1 0 23.8-6.3 30.3-17.5 9.5-16.7 3.8-38.1-13-47.8zm-177.6 3.5c-11.7-9-19.8-22.5-21.9-37.9-.3-2.5-.5-5-.5-7.6s.2-5.1.5-7.6c2-15.4 10.2-28.8 21.9-37.9 4-3.1 8.4-5.6 13.1-7.6 6.7-2.8 14.1-4.3 21.9-4.3 7.7 0 15.1 1.5 21.9 4.3 4.7 1.9 9.1 4.5 13.1 7.6 11.7 9 19.8 22.5 21.9 37.9.3 2.5.5 5 .5 7.6s-.2 5.1-.5 7.6c-2 15.4-10.2 28.8-21.9 37.9-4 3.1-8.4 5.6-13.1 7.6-6.7 2.8-14.1 4.3-21.9 4.3-7.7 0-15.1-1.5-21.9-4.3-4.7-2-9.1-4.5-13.1-7.6z"
        />
        <path
          d="M941.8 365.2 727.3 150.7c-7.5-7.5-17.9-11.2-28.4-10.1-10.5 1.1-19.9 6.9-25.6 15.7-.7 1-69.6 104.7-160.9 104.7h-.8c-91.3 0-160.2-103.7-160.9-104.6-5.7-8.9-15.2-14.6-25.7-15.7-10.5-1.1-20.9 2.6-28.4 10L82.2 365.2c-13.7 13.7-13.7 35.8 0 49.4l105.7 105.7c6.8 6.8 15.8 10.2 24.7 10.2 8.9 0 17.9-3.4 24.7-10.2l36-36V731c0 54.7 14.5 94.9 43 119.6 23.7 20.5 49.9 23.7 64.1 23.7 2.7 0 4.9-.1 6.6-.3h101.2c19.3 0 35-15.7 35-35s-15.7-35-35-35H385.4c-2.2 0-2.7-.1-4.6.3-2.2.1-11.5 0-19.4-7.3-11.7-10.8-18.2-34.3-18.2-66.2V404.1c0-19.3-15.7-35-35-35-1 0-1.9 0-2.8.1-9.4-.4-19 3-26.2 10.2L212.6 446l-56.2-56.2 161.7-161.7C353.4 268.7 422.2 331 511.6 331h.8c89.4 0 158.2-62.3 193.5-102.8l161.7 161.7-56.2 56.2-62.8-62.8c-6.3-9.4-16.9-15.5-29.1-15.5-19.3 0-35 15.7-35 35V457c0 19.3 15.7 35 35 35 10.6 0 20.2-4.8 26.6-12.3l40.6 40.6c6.8 6.8 15.8 10.2 24.7 10.2 8.9 0 17.9-3.4 24.7-10.2l105.7-105.7c6.6-6.6 10.2-15.4 10.2-24.7s-3.7-18.2-10.2-24.7z"
        />
      </g>
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.3em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
